<template>
	<div class="w_100 h_100 cbox">
		<div v-if="false" class="headbar">
			<div style="float: right">
				<el-button icon="el-icon-upload" style="margin-left:10px" size="small"
					@click="dialogShow3 = true">导入就业名册</el-button>
			</div>
		</div>
		<div class="w_100 h_100 bcontent flexCloumn" style="padding:20px 0;">
      <div class="w_100 h_100 flexCloumn">
        <div class="w_100 flexBetween">
          <div class="w_100 flexStart">
            <el-cascader ref="firstCascader" :options="TreeData" :props="defaultProps" :show-all-levels="true"
                         @change="getSelectType" clearable placeholder="请选择班级" filterable
                         style="width: 250px;" size="small">
            </el-cascader>

            <el-select size="small" v-model="searchForm.xuezhi" placeholder="学制" clearable style="width:150px;margin-left: 10px;">
              <el-option label="中职" value="中职"></el-option>
              <el-option label="高职" value="高职"></el-option>
            </el-select>
            <el-input v-model="searchForm.keyword" clearable size="small" placeholder="姓名/专业/手机号" style="width: 250px;margin-left: 10px;"></el-input>
            <el-button icon="el-icon-search" @click="getDataList" style="margin-left:10px" size="small"
                       type="primary">搜索</el-button>
            <el-button size="small" icon="el-icon-question" @click="manualDownload">使用手册</el-button>
          </div>
          <div class="w_100 headbar flexEnd borderbox" style="padding:0 10px 0 0;border:0;">
            <div style="">

              <el-button v-if="$store.state.pmid != 1" icon="el-icon-upload" size="small" type="text" title="导入"
                         @click="beforeUploadCheck(1)">导入专业技能证书</el-button>

              <el-button v-if="$store.state.pmid != 1" icon="el-icon-upload" style="margin-left:10px" size="small" type="text" title="导入"
                         @click="beforeUploadCheck(2)">导入其他证书</el-button>
            </div>
            <el-button class="ml20" @click="initFullTables" size="middle" type="text" title="全屏展示表格，也可双击表格全屏展示"> <i
              class="el-icon-full-screen" style="font-size:24px!important;"></i></el-button>
          </div>
        </div>

        <div class="w_100 flexCloumn" id="myFullTable" @dblclick="initFullTables"
             style=" margin:0 auto;height:calc(100% - 50px); position: relative;background-color: #fff;">
          <el-table id="table" ref="table" :data="tableData" row-key="id" class="flex_1 mytable"
                    header-row-class-name="mytableheader"
                    stripe
                    border
                    height="100%" style="width:fit-content;width:100%;">
            <el-table-column type="index" label="序号" width="55px" align="center"></el-table-column>
            <el-table-column label="姓名" prop="stu_name" width="100" align="center"></el-table-column>
            <el-table-column label="性别" prop="gender" width="80" align="center"></el-table-column>
            <el-table-column label="年龄" prop="age" width="80" align="center"></el-table-column>
            <el-table-column label="学制" prop="xuezhi" width="80" align="center"></el-table-column>
            <el-table-column label="就业去向" prop="jyqx" width="80" align="center"></el-table-column>
            <el-table-column label="专业名称" prop="xibu_name" width="140" align="center"></el-table-column>
            <el-table-column label="专业类别" prop="zhuanye_type" width="140" align="center"></el-table-column>
            <el-table-column label="专业代码" prop="zydm" width="120" align="center"></el-table-column>
            <el-table-column label="最高职业技能等级/职业资格证" prop="prize_skill" width="140" align="center"></el-table-column>
            <el-table-column label="全日制升学" align="center">
              <el-table-column label="学校名称" prop="enter_name" width="180" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quxiang == '升入高一级学校' ? scope.row.enter_name : '' }}
                </template>
              </el-table-column>
              <el-table-column label="学历" prop="enter_type" width="100" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quxiang == '升入高一级学校' ? scope.row.enter_type : '' }}
                </template>
              </el-table-column>

            </el-table-column>
            <!-- <el-table-column label="毕业去向" prop="quxiang" width="180" align="center"></el-table-column> -->
            <el-table-column label="就业状况" align="center">

              <el-table-column label="就业单位名称" prop="enter_name" width="180" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quxiang != '升入高一级学校' ? scope.row.enter_name : '' }}
                </template>
              </el-table-column>
              <el-table-column label="单位地址（省、市）" prop="enter_addr" width="130"
                               align="center"></el-table-column>
              <el-table-column label="单位地点类别" prop="didian" width="120" align="center"></el-table-column>
              <el-table-column label="单位性质" prop="dwxz" min-width="150" align="center"></el-table-column>
              <el-table-column label="所属产业" prop="chanye" width="120" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quxiang != '升入高一级学校' ? scope.row.chanye : '' }}
                </template>
              </el-table-column>
              <el-table-column label="部门" prop="stu_dept" width="120" align="center"></el-table-column>
              <el-table-column label="岗位" prop="stu_job" width="120" align="center"></el-table-column>
              <el-table-column label="是否对口就业" prop="duikou" width="80" align="center"></el-table-column>
              <el-table-column label="是否学校推荐" prop="qudao" width="80" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quxiang != '升入高一级学校' ? (scope.row.qudao == '学校推荐' ? '是' : scope.row.qudao == '自联' ? '否' : scope.row.qudao) : '' }}
                </template>

              </el-table-column>
            </el-table-column>

            <el-table-column label="劳 动 保 障" align="center">

              <el-table-column label="有否劳动合同" prop="hetong" width="80" align="center">

              </el-table-column>
              <el-table-column label="有否三险五险" prop="enter_type" width="80" align="center">
                <template slot-scope="scope">
                  {{ scope.row.wuxian.replace('一金', '') }}
                </template>
              </el-table-column>
              <el-table-column label="有否公积金" prop="gongjijin" width="80" align="center">

              </el-table-column>
              <el-table-column label="平均月工资(元)" prop="salary" width="100" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quxiang != '升入高一级学校' ? scope.row.salary : '' }}
                </template>
              </el-table-column>

            </el-table-column>
            <el-table-column label="联 系 电 话" align="center">

              <el-table-column label="本人电话" prop="lxdh" width="130" align="center"></el-table-column>
              <el-table-column label="家长电话" prop="lxdh" width="130" align="center"></el-table-column>
            </el-table-column>

            <el-table-column label="就业是否满意" prop="manyidu" width="80" align="center"></el-table-column>
            <el-table-column label="备注" prop="bz" width="150" align="center"></el-table-column>

            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="viewInfo(scope.row)" type="text" size="small">详情</el-button>
<!--                <el-button v-if="$store.state.sysopened" @click="deleteRow(scope.row)" type="text" size="small">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>

           <div style="text-align:right;padding-top: 10px;">
                      <el-pagination background @current-change="handlePageChange" :current-page="page.current_page"
                          :page-size="page.per_page" :total="page.count"
                          layout="total, prev, pager, next"></el-pagination>
                  </div>
        </div>
        <jiuyeinfo v-if="infoShow" :id="sxId"></jiuyeinfo>

        <!----专业证书导入------>
        <el-dialog class="cus_dialog " title="专业技能证书" :visible.sync="dialogShow" :close-on-click-modal="false"
                   width="600px" height="30%">
          <div style="line-height: 50px;">
            <a href="javascript:;" @click="download_import_module(1)">证书导入模板下载（excel/xls）</a>
          </div>
          <div style="line-height: 50px; color:orangered">
            请严格按照模板格式填入正确的数值
          </div>

          <div class="mb10">
            <el-alert v-if="uploadBtn" type="warning" title="提醒" show-icon :closable="false">{{ uploadErrMsg }}</el-alert>
          </div>
          <div style="text-align:right">
            <el-upload style="display: inline-block; margin-right: 20px;" action="" :http-request="uploadTemp"
                       :on-success="uploadFiles"
                       :show-file-list="false" name="image" accept=".xls,.xlsx">
              <el-button icon="el-icon-upload" type="primary" style="margin-left:100px"
                         size="small" :disabled="uploadBtn">选择文件</el-button>
            </el-upload>
          </div>
        </el-dialog>

        <!----其他证书导入------>
        <el-dialog class="cus_dialog " title="其他证书" :visible.sync="dialogShow1" :close-on-click-modal="false"
                   width="600px" height="30%">
          <div style="line-height: 50px;">
            <a href="javascript:;" @click="download_import_module(2)">证书导入模板下载（excel/xls）</a>
          </div>
          <div style="line-height: 50px; color:orangered">
            请严格按照模板格式填入正确的数值
          </div>
          <div class="mb10">
            <el-alert v-if="uploadBtn" type="warning" title="提醒" show-icon :closable="false">{{ uploadErrMsg }}</el-alert>
          </div>
          <div style="text-align:right">
            <el-upload style="display: inline-block; margin-right: 20px;" action="" :http-request="uploadTemp"
                       :on-success="uploadFiles1" :show-file-list="false" name="image" accept=".xls,.xlsx">
              <el-button icon="el-icon-upload" type="primary" style="margin-left:100px"
                         size="small" :disabled="uploadBtn">选择文件</el-button>
            </el-upload>
          </div>
        </el-dialog>
      </div>
		</div>
	</div>
</template>

<script>

import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
import jiuyeinfo from '../pages/com/jiuyeinfo.vue'
export default {
	components: {jiuyeinfo},
	data() {
		return {
			dialogShow: false,
      dialogShow1: false,
      infoShow: false,
			dialogShow3: false,
			dialogSxShow: false,
			activeName: "forth",
      searchForm: {},
			teacherInfo: {},
      defaultProps: {
        label: 'name',
        value: 'value',
        children: 'children',
        emitPath: true,
        checkStrictly: true,

      },
			tjData: null,
      TreeData: [],
			shengxue: {
				total: 0,
				okfile: 0,
				nofile: 0
			},
			tableData: [],
			tempid: 0,
      sxId: 0,
			guidenceUrl: '',
      page: {
        count: 0,
        current_page: 1,
        per_page: 20,
        total_page: 0
      },
      uploadBtn: true,
      uploadErrMsg: '',
		}
	},
	mounted() {
		this.getGuidenceUrl()
		this.getDataList()
		this.getteacherInfo()
    this.getTree()
	},
	methods: {
    getTree() {
      this.$http.post("/api/jymingce_grade_tree", { school_id: this.tpmid }).then(res => {
        this.TreeData = res.data
      })
    },
		getGuidenceUrl() {
			this.$http.post("/api/sch_configs").then(res => {
				for (let k of res.data) {
					if (k.ktype == 'guidenceUrl_All') {
						this.guidenceUrl = k.kvalue
					}
				}
			})
		},
		openGuidence() {
			// window.open(this.guidenceUrl)
			let a = document.createElement("a");
			fetch(this.guidenceUrl)
				.then((res) => res.blob())
				.then((blob) => {
					a.href = URL.createObjectURL(blob);
					a.download = '使用手册';
					a.style.display = "none";
					a.click();
					window.URL.revokeObjectURL(a.href);
				})
		},
		download_import_module(type) {
      const load = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let path = type == 1 ? '/api/download_jnjd_template' : '/api/download_other_template'
      // let path = type == 1 ? '/api/download_jnjd_template_2026' : '/api/download_other_template'
      this.$http.post(path, this.searchForm).then(res => {
        load.close()
        window.open(res.data.url,'_blank')
      }).catch(() => {
        load.close();
      })
		},
		getShengxue() {
			this.$http.post("/api/jymingce_shengxue_tongji").then(res => {
				this.shengxue = res.data
			})
		}, showShengxue() {
			this.$http.post("/api/jymingce_sx_students").then(res => {
				this.tableData = res.data
				this.dialogSxShow = true
			})
		},
		getteacherInfo() {
			this.$http.post("/api/get_teacher_info").then(res => {

				this.teacherInfo = res.data
			})
		},
		handleClick() {
			if (this.activeName == "second") {
				this.$nextTick(e => {
					$("table", "#tableContent").addClass("dttable")
				})
			}
		},
		getDataList() {
			this.$http.post("/api/jnjdzs_list", {
        page: this.page.current_page,
        pagesize: this.page.per_page,
        ...this.searchForm
      }).then(res => {
				this.tableData = res.data.data;
        this.page = res.data.page
			})


		},
		handlePageChange(page) {
			this.page.current_page = page;
			this.getDataList();
		},
		viewInfo(e) {
			// e.keyword = this.searchForm.keyword
			// e.xibu_name = this.searchForm.xibu_name
			// e.class_name = this.searchForm.class_name
			this.sxId = e.id;
			this.infoShow = true
		},
		uploadFiles(e) {
			this.$http.post("/api/import_jnjdzs", {
        // import_jnjdzs_2026 导入技能鉴定（带学生信息）
			// this.$http.post("/api/import_jnjdzs_2026", {
        url: e.src
      }).then(res => {
        if (res.data.errors && res.data.errors.length > 0) {
          let html = ''
          for (let error of res.data.errors) {
            html += "<div style='font-size:12px'>" + error.msg + "</div>"
          }
          this.$alert(html, `未导入数据${res.data.errors.length}条`, {
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            cancelButtonText:"取消",
            distinguishCancelAndClose: true,
          });
        } else {
          this.$message.success("导入成功")
          this.dialogShow = false;
          this.getDataList()
        }
      })
		},
    uploadFiles1(e) {
      this.$http.post("/api/import_other_cert", {
        url: e.src
      }).then(res => {
        if (res.data.errors && res.data.errors.length > 0) {
          let html = ''
          for (let error of res.data.errors) {
            html += "<div style='font-size:12px'>" + error.msg + "</div>"
          }
          this.$alert(html, `未导入数据${res.data.errors.length}条`, {
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            cancelButtonText:"取消",
            distinguishCancelAndClose: true,
          });
        } else {
          this.$message.success("导入成功")
          this.dialogShow1 = false;
          this.getDataList()
        }
      })
    },
		uploadFiles3(e) {
			if (e.src.indexOf("xls") > 0) {

				this.$http.post("/api/import_jiuyemingche_xls2024", {
					url: e.src,
          filename: e.fileName,
				}).then(res => {

					if (res.data.errors && res.data.errors.length > 0) {
						let html = ''
						for (let error of res.data.errors) {
							html += "<div style='font-size:12px'>" + error.msg + "</div>"
						}
						this.$alert(html, `未导入数据${res.data.errors.length}条`, {
							dangerouslyUseHTMLString: true,
              showCancelButton: true,
              cancelButtonText:"下载未导入数据",
              distinguishCancelAndClose: true,
              beforeClose: (action, instance, done) => {
                if (action === 'cancel') {
                  this.exportToExcel([{name:"未导入数据",fails: res.data.errors}])
                }
                done()
              }
						});
					} else {
						this.$message.success("导入成功")
					}

					this.dialogShow = false
					this.activeName = ""
					this.$nextTick(e => {
						this.activeName = "forth"
					})

				})

			} else if (e.src.indexOf("zip") > 0) {

				this.$http.post("/api/import_jiuyemingche_xls2024zip", {
					url: e.src
				}).then(res => {
          let showCancel = false
          let errors = res.data.errors
          let html = ""
          for (let error of errors) {
            if (error.msg) {
              html += `<div style='font-size:12px'>“${error.name}”文件中，${error.msg}</div>`
            }
            if (error.fails.length) {
              showCancel = true
              html += `<div style='font-size:12px'>“${error.name}”文件中，未导入数据${error.fails.length}条</div>`
            }
          }

          if (html) {
            this.$alert(html, '未导入数据', {
              dangerouslyUseHTMLString: true,
              showCancelButton: showCancel,
              cancelButtonText: "下载未导入数据",
              distinguishCancelAndClose: true,
              beforeClose: (action, instance, done) => {
                if (action === 'cancel') {
                  this.exportToExcel(errors)
                }
                done()
              }
            });
          } else {
            this.$message.success("导入成功")
          }

					/*if (res.data.msg && res.data.msg.length > 0) {
						let html = ''
						for (let msg of res.data.msg) {
							html += "<div style='font-size:12px'>" + msg.msg + "</div>"
						}
						this.$alert(html, '未导入数据', {
							dangerouslyUseHTMLString: true
						});
					} else {
						this.$message.success("导入成功")
					}*/

					this.dialogShow3 = false
					this.activeName = ""
					this.$nextTick(e => {
						this.activeName = "forth"
					})

				})

			} else {
				this.$message.error("请上传Xls格式文件")
			}
		},
		chooseTzs(e) {
			this.tempid = e.id
			document.getElementById("btntzs").click()
		},
		uploadTzs(e) {
			if (e.src) {

				this.$http.post("/api/jymingce_sx_tzs", {
					url: e.src,
					id: this.tempid
				}).then(res => {
					this.getShengxue()
					this.showShengxue()

				})

			}
		},
    exportToExcel(data) {
      let headers = ["行号","姓名","错误描述"
        ]
      let workbook = XLSX.utils.book_new()
      for (let item of data) {
        if (!item.fails.length) {
          continue
        }
        let exportData = [headers]
        for (let error of item.fails) {
          let arr = [error.ID,error['__EMPTY'],error.msg]
          exportData.push(arr)
        }
        let ws = XLSX.utils.aoa_to_sheet(exportData)
        XLSX.utils.book_append_sheet(workbook,ws, item.name)
      }
      let buf = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' })
      const blob = new Blob([buf], {type: "application/octet-stream;charset=utf-8'"})
      FileSaver.saveAs(blob, `未导入数据.xlsx`)
    },
    getSelectType(e) {
      let node = this.$refs['firstCascader'].getCheckedNodes()
      if (node[0]) {
        let path = node[0].pathNodes[0].label
        if (node[0].pathNodes.length >= 2) {
          this.searchForm.xibu_name = node[0].pathNodes[0].label
          this.searchForm.class_name = node[0].pathNodes[1].label
        } else if (node[0].pathNodes.length >= 1) {
          this.searchForm.xibu_name = node[0].pathNodes[0].label
          this.searchForm.class_name = ""
        } else {
          this.searchForm.xibu_name = ""
          this.searchForm.class_name = ""
        }
      } else {
        this.searchForm.xibu_name = ""
        this.searchForm.class_name = ""

      }
    },
    beforeUploadCheck(type) {
      this.dialogShow = type == 1
      this.dialogShow1 = type == 2
      let rtype = type == 1 ? 'zyjnzs' : 'qtjnzs'
      let errMsg = `上传按钮暂时不可用，请先上传各专业${type == 1 ? '专业技能证书' : '其他证书'}`
      // this.$http.post('/api/jymcfiles_check', {report_type:rtype}).then(res => {
      //   this.uploadBtn = res.data.status ? false : true;
      //   this.uploadErrMsg = this.uploadBtn ? errMsg : ''
      // })
      // 前置校验改为：jnjd_table（专业技能证书）/ other_cert_list（其他证书）返回值中没有数据时，按钮不可用并提示
      let checkUrl = type == 1 ? '/api/jnjd_table' : '/api/other_cert_list'
      // ignore_year：探测不按年份过滤（与 jnjd_table 跨年口径一致），列表页调用不受影响
      this.$http.post(checkUrl, { page: 1, pagesize: 1, ignore_year: 1 }).then(res => {
        let rows = res.data.data || []
        let hasData = (res.data.page && Number(res.data.page.count) > 0) || rows.length > 0
        this.uploadBtn = !hasData
        this.uploadErrMsg = this.uploadBtn ? errMsg : ''
      })
    },
    manualDownload() {
      this.$http.post('/api/sch_config_jyj',{ktype:'jnjd_manual_url'}).then(res => {
        if (res.data.length) {
          this.$http.get(res.data[0].kvalue,{responseType:'arraybuffer'}).then(r=> {
            const blob = new Blob([r.data], { type: 'application/octet-stream;charset=UTF-8' })
            const downloadElement = document.createElement('a')
            const href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.style.display = 'none'
            downloadElement.href = href
            downloadElement.download = decodeURIComponent('技能鉴定使用手册.docx') // 下载后文件名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href)
          })
        }
      })
    }
	}
}
</script>
<style scoped></style>
